import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { Row, Col, Button, Form} from 'react-bootstrap'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-enterprise'
import { DisplayedGroupCreator } from 'ag-grid-enterprise';
import JoditEditor from 'jodit-react';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';

function CreateCampaign(props){

    const [templates, setTemplates] = useState([])
    const [jobs, setJobs] = useState([])
    const [smtpCredentials,setSmtpCredentials]=useState([])

    const [selectedJob, setSelectedJob] = useState(-1)
    const [selectedTemplateId,setSelectedTemplateId]=useState(props.templateid?props.templateid:-1)
    const campaignIdRef=useRef(-1)
    const [selectedSmtpCredentials,setSelectedSmtpCredentials]=useState([])

    const [includeGenericEmails,setIncludeGenericEmails]=useState(true)
    const [includeSystemGeneratedEmails,setIncludeSystemGeneratedEmails]=useState(false)
    const [selectedFormat,setSelectedFormat]=useState(-1)

    const [rowFormData,setRowFormData]=useState({})
    const attachmentRef=useRef()
    const editor = useRef(null);
	const config =useMemo(()=>{ return {
        readonly: false, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: 'Start typing...',
        height:285
    }},[]);
    const [validated, setValidated] = useState(false);
    
    const [isTemplateValid,setIsTemplateValid]=useState(undefined)
    const [isJobValid,setIsJobValid]=useState(undefined)
    const [isSmtpCreadentialsValid,setIsSmtpCreadentialsValid]=useState(undefined)
    const [message,setMessage]=useState('')
    const [showAddEmailModal,setShowAddEmailModal]=useState(false)
    const [emailsForAdding,setEmailsForAdding]=useState('')
    const [disableTemplateDropDown,setDisableTemplateDropDown]=useState(false)
    const [disableJobDropDown,setDisableJobDropDown]=useState(false)

    const selectSmtpRef=useRef()
    const [selectKey,setSelectKey]=useState(Date.now())
    const getTemplates = () => {
        axios.get(`/emailtemplates/userid/${props.uid}`)
            .then(res => {
                setTemplates(res.data)
                // props.setTemplates(res.data)
                // props.setSelectedTemplate(res.data[0].id)
            })
            .catch(err => {
                console.log(err)
            })
    }

    const getsmtpcredentials = () => {
        axios.get(`/smtpcreadentials/userid/${props.uid}`)
            .then(result => {
                setSmtpCredentials(result.data.map(elem=>{return {value:elem.id,label:elem.title}}))
            })
            .catch(err => {
                console.log(err)
            })
    }

    const getjobs = () => {
        axios.get(`/getjobswithemails/userid/${props.uid}`)
            .then(result => {
                setJobs(result.data)
                props.setShowstartmodal(true)
            })
            .catch(err => {
                console.log(err)
            })
    }

    const startcampaign = async (event) => {
        let fileds=[]

        if(!(props.campaignid>0))
        {
            if(selectedTemplateId==-1)
            // setIsTemplateValid(false)
            fileds.push('Email Template')
            if(selectedJob==-1)
            // setIsJobValid(false)
            fileds.push('List')
        
        }   
        if(selectedSmtpCredentials.length==0)
            // setIsSmtpCreadentialsValid(false)
            fileds.push('SMTP Credentials')

        if(fileds.length>0)
        {
            alert('Please select following fields: '+fileds.join(','))
        }
        else 
        {   if(campaignIdRef.current==-1)
                alert("Something wrong happened")
            else 
            {
                if(window.confirm('Are you sure you want start email campaign?'))
                {   
                    try{
                        const smtpcredids=selectedSmtpCredentials.map(elem=>elem.value)
                        console.log('smtpcredids:',smtpcredids)
                        await axios.patch(`/emailscampaign/${props.uid}/${campaignIdRef.current}/${JSON.stringify(smtpcredids)}`)
                        await axios.post(`/runemailcampaign/${campaignIdRef.current}`)
                        alert(`Campaign Started!`)
                        
                        props.setShowstartmodal(false)
                        
                    }catch(err)
                    {
                        alert('Something went wrong, please try again after some time')
                        console.log(err)  
                    }
                    
                  
                }
            }
        }

    }

    const handletemplateselect = (event) => {
        setSelectedTemplateId(event.target.value)
        // if(event.target.value===-1)
        //     setIsTemplateValid(false)
        // else
        // setIsTemplateValid(true)
    }
    const handlejobselect = (event) => {
        setSelectedJob(event.target.value)
        // if(event.target.value===-1)
        //     setIsJobValid(false)
        // else
        //     setIsJobValid(true)
    }
    // const handlesmtpselect = (event) => {
    //     setSelectedSmtpCredentials(event.target.value)
    //     // if(event.target.value===-1)
    //     //     setIsSmtpCreadentialsValid(false)
    //     // else
    //     //     setIsSmtpCreadentialsValid(true)
    // }
    
    async function createCampaign(){
        const request = {
            url: '/emailcampaigns',
            data: {templateid:selectedTemplateId, smtpcredentialsid:0, jobid:selectedJob,createdby:props.uid,fromLeadsScreen:0},
            method: "POST"
        }

        if (request) {
            axios(request)
            .then((result) => {
                campaignIdRef.current=result.data.campaignid
                gridRef.current.api?.refreshServerSide({purge:true});
                
            })
            .catch((err) => {
                console.log('error occured while creating email campaign', err)
            })
        }
    }

    // const getCampaignDetails=(campaignid)=>{
    //     axios.get(`/emailscampaign/${campaignid}`)
    //     .then((res)=>{
    //         console.log('templateId: ',res.data.tempplateid)
    //         setSelectedTemplateId(res.data.tempplateid)
    //     })
    //     .catch((err)=>{

    //     })
    // }

    useEffect(()=>{

        if(parseInt(props.campaignid)>0)
        {
            setDisableTemplateDropDown(true)
            setDisableJobDropDown(true)
            campaignIdRef.current=props.campaignid

        }
        getTemplates();
        getjobs()
        getsmtpcredentials()

        
    },[])

    //when list or job changed
    useEffect(()=>{
        if(selectedTemplateId!=-1&&selectedJob!=-1)
        {   
            createCampaign()

            setIncludeGenericEmails(true)
            setIncludeSystemGeneratedEmails(false)
            setSelectedFormat(-1)
        }
    },[selectedTemplateId,selectedJob])

    useEffect(()=>{

        const request = {
            url: `/campaigndetails/includegenericemails/${campaignIdRef.current}/${includeGenericEmails?1:0}`,
            data: {},
            method: "PUT"
        }

        if (request) {
            axios(request).then(() => {
                gridRef.current.api?.refreshServerSide({purge:true});
                
            })
                .catch((err) => {
                    alert('Something wrong happened. Can you please try after some time?')
                })
        }
    },[includeGenericEmails])

    useEffect(()=>{
        if(selectedFormat!==-1)
        {
            const request = {
            url: `/campaigndetails/includegeneratedemails/${campaignIdRef.current}/${includeSystemGeneratedEmails?1:0}/${selectedFormat}`,
            data: {},
            method: "PUT"
            }

            if (request) {
                axios(request).then(() => {
                    gridRef.current.api?.refreshServerSide({purge:true});
                    
                })
                    .catch((err) => {
                        alert('Something wrong happened. Can you please try after some time?')
                    })
            }
        }
    },[selectedFormat,includeSystemGeneratedEmails])

    //AgGrid

    const columns = [
        {
            //headerCheckboxSelection: true, // Adds a checkbox to the header for selecting all rows
            checkboxSelection: true,       // Adds checkboxes to the rows
            headerName: "Select",
            width: 50, 
            sortable:false
        },
        { field: 'id', headerName: 'Id', hide:"true", filter: 'agNumberColumnFilter'},
        { field:"i", headerName:"No.", width:"80",valueGetter:'node.rowIndex+1',sortable:false},
        { field: 'email', headerName: 'Email', filter: 'agTextColumnFilter'},
        { field: 'name', headerName: 'Business Name', filter: 'agTextColumnFilter'},
        { field: 'person', headerName: 'Person', filter: 'agTextColumnFilter'},
        { field: 'bcc', headerName: 'bcc', filter: 'agTextColumnFilter' },
        { field: 'iscustom', headerName: 'Is Custom', filter: 'agNumberColumnFilter' },

        { field: 'displayname', hide:"true" },
        { field: 'to', hide:"true" },
        { field: 'cc', hide:"true" },
        { field: 'subject', hide:"true" },
        { field: 'body', hide:"true" },
        { field: 'attachments', hide:"true" }

    ];


    const gridRef = useRef();
    const selectionGridRef=useRef();

    const datasource = {
        getRows: function (params)  {
            const serverApiUrl = `/api/emailcampaigndetails`;

            fetch(serverApiUrl, {
                method: 'post',
                body: JSON.stringify({...params.request, tablename:`vw_emailcampaigndetails`,campaignid:campaignIdRef.current}),
                headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
            })
            .then(httpResponse => httpResponse.json())
            .then(response => {
                params.successCallback(response.rows, response.lastRow);
            })
            .then(()=>{
                const nodesToSelect = [];
                gridRef.current.api.forEachNode((node) => {
                        if(node.data.selected==1) 
                            nodesToSelect.push(node)
                });
                gridRef.current.api.setNodesSelected({ nodes: nodesToSelect, newValue: true });
            })
            .catch(error => {
                console.error(error);
                params.failCallback();
            });
        }
    };

    const selectiongriddatasource = {
        getRows: function (params)  {
            const serverApiUrl = `/api/emailcampaigndetailsselected`;

            fetch(serverApiUrl, {
                method: 'post',
                body: JSON.stringify({...params.request, tablename:`emailcampaigndetails`,campaignid:campaignIdRef.current}),
                headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
            })
            .then(httpResponse => httpResponse.json())
            .then(response => {
                params.successCallback(response.rows, response.lastRow);
            })
            .catch(error => {
                console.error(error);
                params.failCallback();
            });
        }
    };

    const defaultColDef={
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle: {textAlign: 'center'}
        // floatingFilter: false,
        // enableValue: true,
        // enableRowGroup: true,
        // enablePivot: true,
    }

    const onGridReady = (params) => {
        gridRef.current.api?.setServerSideDatasource(datasource);
        
    };

    const onSelectionGridReady = (params) => {
        selectionGridRef.current.api?.setServerSideDatasource(selectiongriddatasource);
        
    };

    const updateSelection=(selectionstate)=>{
        console.log('update selection called')
        const filterModel = gridRef.current.api?.getFilterModel();
        const serverApiUrl = `/api/updateecselection/${campaignIdRef.current}/${selectionstate?1:0}`;
        const request = {
            "startRow": 0,
            "endRow": -1,
            "rowGroupCols": [],
            "valueCols": [],
            "pivotCols": [],
            "pivotMode": false,
            "groupKeys": [],
            "filterModel": filterModel,
            "sortModel": []
        };

        fetch(serverApiUrl, {
            method: 'post',
            body: JSON.stringify(request),
            headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
        })
        .then(response => {
            console.log(response)
            gridRef.current.api?.forEachNode((node)=>node.setSelected(selectionstate),true)
        }) //httpResponse.json()
        // .then(response => {
        //     setSelectedRows(response.rows);

        //     const filteredRows = response.rows.filter(row => (!selectedRowData.map(o => o.id).includes(row.id)))
        //     setSelectedRowData(prevselectedRowData => [...prevselectedRowData, ...filteredRows]);
        // })
        .catch(error => {
            alert('Something went wrong please try after some time')
            console.error(error);
        });
    }
    const handleSelectAll=()=>{
        updateSelection(true)
    }
    const handleUnSelectAll=()=>{
        updateSelection(false)
    }
    const onRowSelected=(event)=>{

        //ppulating update form
        let row=event.data
        let tmp_attachments=[]
        
        for(let a of JSON.parse(row.attachments))
            tmp_attachments.push(a.filename)
        let str_attachment=tmp_attachments.join(', ')

        setRowFormData({...row,attachments:str_attachment})

        //saving selection on server side
        const selectionState=event.node.selected
        const selectedRowId=row.id
        console.log(selectedRowId,selectionState)

        axios.patch(`/emailcampaigndetails/${selectedRowId}/${selectionState?1:0}`)
        .then(()=>console.log('changed successfully'))
        .catch((err)=>{
            console.log('something went wrong please try again after some time')
            // event.setSelected(!selectionState)
        })
    }

    const handleAddEmails = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();
        if (form.checkValidity() === true) 
        {
            try{
                setShowAddEmailModal(false)
                if (emailsForAdding) {
                    await axios({url:'/emailcampaigndetails-addemails',
                        data:{
                            campaignid:campaignIdRef.current,
                            templateid:selectedTemplateId,
                            emails:emailsForAdding
                        },
                        method:'POST'
                    })
                }
        }catch(err)
        {
            alert('Something went wrong please try again after some time')
        }
        } 
      }


    // const onSelectionChanged = () => {
        // const selectedRows = gridRef.current.api.getSelectedRows();

        // let row=selectedRows[0]
        // let tmp_attachments=[]
        
        // for(let a of JSON.parse(row.attachments))
        //     tmp_attachments.push(a.filename)
        // let str_attachment=tmp_attachments.join(', ')

        // setRowFormData({...row,attachments:str_attachment})

        // console.log('Selected rows:', selectedRows[0]);
    //   };

      const handleChange = (e) => {
        const { name, value } = e.target;
        setRowFormData({ ...rowFormData, [name]: value })
    }

    const handleUpdate = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;

        if (form.checkValidity() === false ) {
        }
        else if (form.checkValidity()===true ) {

            let data = new FormData();
            for (const [key, val] of Object.entries(rowFormData))
                data.set(key, val);
            data.set('modifiedby', props.uid);

            for(let file of attachmentRef.current.files)
                data.set(file.name, file);

            const response=await fetch('/api/emailcampaigndetails',{
                method:"PUT",
                body:data,
                headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
            })

            if(response.ok){
                alert('Email details modified')
                setRowFormData({})
                setValidated(true)
            }
            else{
                alert('Something wrong happened. Can you please try after some time?')
            }
        }

        setValidated(true);
    }

    const onModelUpdated = (params) => {
        gridRef.current.api.forEachNode((node) => {
                if(node.data?.selected==1)
                    node.setSelected(true)
        });
    };

    const handleCancel = async () => {
        
        if(campaignIdRef.current)
        {
            axios.put(`/deletetmpemailcampaigns/${campaignIdRef.current}`)
            .then(res => {
                props.setShowstartmodal(false)
            })
            .catch(err => {
                props.setShowstartmodal(false)
            })
        }
        else  props.setShowstartmodal(false)
    }



    return <>
    <div className='h-100' >
        <Row>
            <Col>
                <Form.Group >
                    <Form.Label className='fw-bold'>Template</Form.Label>
                    <Form.Select onChange={handletemplateselect} size="sm" value={selectedTemplateId} disabled={disableTemplateDropDown}>
                        <option key='default' value={-1}>
                            Select Email Template
                        </option>
                        {templates.map((option, index) => (
                            <option key={index} value={option.id} >
                                [ID-{props.uid}00{option.id}]  {option.title} 
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col>
                <Form.Group >
                    <Form.Label className='fw-bold'>List</Form.Label>
                    <Form.Select id="selectOptions" onChange={handlejobselect} size="sm" value={selectedJob} disabled={disableJobDropDown}>
                        <option key='default' value={-1}>
                            Select list
                        </option>
                        {jobs.map((option, index) => (
                            <option key={index} value={option.id} disabled={ [2,3].includes(option.status) ? false : true} >
                                [ID-{props.uid}00{option.id}] {option.name}
                                {/* ( {option.emailcount} emails ) */}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col>
                
                <Row className='w-100 mt-1'>
                    <Col>
                            <Form.Check
                                className='fw-bold'
                                inline
                                label="Include Generic Emails"
                                type='checkbox'
                                defaultChecked={true}
                                disabled={!(campaignIdRef.current>0)}
                                checked={includeGenericEmails}
                                onChange={()=>setIncludeGenericEmails(!includeGenericEmails)}
                            />
                            <Form.Check
                                onChange={()=>setIncludeSystemGeneratedEmails(!includeSystemGeneratedEmails)}
                                className='fw-bold'
                                inline
                                label="Include System-generated email IDs"
                                type='checkbox'
                                checked={includeSystemGeneratedEmails}
                                disabled={!(campaignIdRef.current>0)}
                            />
                    </Col>
                    </Row>
                    {/* style={{visibility:includeSystemGeneratedEmails?'visible':'hidden'}} */}
                        <Row className={`w-100 mt-1`} > 
                            {/* <Col sm={2}>
                                <div className='fw-bold'> Select Format</div>
                            </Col> */}
                            <Col>
                                <Form.Check
                                    disabled={!includeSystemGeneratedEmails}
                                    inline
                                    label="first.last@domain"
                                    name="format"
                                    type='radio'
                                    onChange={()=>setSelectedFormat(1)}
                                    checked={selectedFormat===1}
                                />
                                <Form.Check
                                disabled={!includeSystemGeneratedEmails}
                                    inline
                                    label="FLast@domain"
                                    name="format"
                                    type='radio'
                                    onChange={()=>setSelectedFormat(2)}
                                    checked={selectedFormat===2}
                                />
                                <Form.Check
                                disabled={!includeSystemGeneratedEmails}
                                    inline
                                    label="first@domain"
                                    name="format"
                                    type='radio'
                                    onChange={()=>setSelectedFormat(3)}
                                    checked={selectedFormat===3}
                                />
                                <Form.Check
                                disabled={!includeSystemGeneratedEmails}
                                    inline
                                    label="firstL@domain"
                                    name="format"
                                    type='radio'
                                    onChange={()=>setSelectedFormat(4)}
                                    checked={selectedFormat===4}
                                />
                            </Col>
                        </Row>
            </Col>
        </Row>
        <Row className='mt-3 w-100'>
            <Col>
            <Row className='m-0 p-0'>
                <Col className='m-0 p-0'>
                    <Button variant="primary" size="sm" className='me-1' onClick={handleSelectAll}>
                       Select All
                    </Button>
                    <Button variant="primary" size="sm" className='me-1' onClick={handleUnSelectAll}>
                       Unselect All
                    </Button>
                    <Button variant="primary" disabled={campaignIdRef.current===-1} size="sm" onClick={()=>{setEmailsForAdding('');setShowAddEmailModal(true)}}>
                       Add Emails
                    </Button>
                </Col>
            </Row>
            <Row className='w-100'>
                <div className="ag-theme-balham m-0 p-2" style={{height:'79vh'}}>
                        <AgGridReact
                            ref={gridRef}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            columnHoverHighlight={'true'}
                            suppressRowGroupHidesColumns={'true'}
                            cacheBlockSize={50}
                            rowModelType={'serverSide'}
                            columnDefs={columns}
                            rowSelection="multiple" // Set to 'single' for single selection
                            // rowSelection={rowSelection}
                            onRowSelected={onRowSelected}
                            //  onFirstDataRendered = {onFirstDataRendered}
                            // onSelectionChanged={onSelectionChanged}
                            // onCellValueChanged={onFirstDataRendered}
                            suppressRowClickSelection={true}
                            rowClickSelection={true}
                            onModelUpdated={onModelUpdated}
                        />               
                </div>
            </Row>
            </Col>
            {/*<Col>
            <Row className='w-100'>
                <div className="ag-theme-balham m-0 p-2" style={{height:'79vh'}}>
                        <AgGridReact
                            ref={selectionGridRef}
                            defaultColDef={defaultColDef}
                            onGridReady={onSelectionGridReady}
                            columnHoverHighlight={'true'}
                            suppressRowGroupHidesColumns={'true'}
                            cacheBlockSize={50}
                            rowModelType={'serverSide'}
                            columnDefs={columns}
                            
                            rowSelection="multiple" // Set to 'single' for single selection
                            // rowSelection={rowSelection}
                            // onFirstDataRendered = {onFirstDataRendered}
                            // onSelectionChanged={onSelectionChanged}
                            // onCellValueChanged={onFirstDataRendered}
                            suppressRowClickSelection={true}
                        />               
                </div>
            </Row>
            </Col>*/}
            <Col sm={4}>
            <Form noValidate validated={validated} onSubmit={handleUpdate}>
                            
                            <Row className="mb-3 mt-2">
                                <Col >
                                    <Form.Group >
                                            <Form.Label className='fw-bold'>Display Name (From){<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                            <Form.Control size="sm"
                                                type="text"
                                                placeholder="eg. ABC Enterprises"
                                                value={rowFormData.displayname}
                                                name='displayname'
                                                onChange={handleChange}
                                                required
                                                pattern={'^[a-zA-Z 0-9]+$'}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid display name.
                                            </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col >
                                    <Form.Group >
                                            <Form.Label className='fw-bold'>To{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                            <Form.Control size="sm"
                                                type="text"
                                                value={rowFormData.to}
                                                name='to'
                                                onChange={handleChange}
                                                required
                                                pattern={'^[{}_,@a-zA-Z0-9.]+$'}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid to email.
                                            </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group >
                                            <Form.Label className='fw-bold'>Cc</Form.Label>
                                            <Form.Control size="sm"
                                                type="text"
                                                value={rowFormData.cc}
                                                name='cc'
                                                onChange={handleChange}
                                                pattern={'^[{}_,@a-zA-Z0-9.]+$'}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid to Cc.
                                            </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                            <Form.Label className='fw-bold'>Bcc</Form.Label>
                                            <Form.Control size="sm"
                                                type="text"
                                                value={rowFormData.bcc}
                                                name='bcc'
                                                onChange={handleChange}
                                                pattern={'^[{}_,@a-zA-Z0-9.]+$'}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide valid Bcc.
                                            </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group >
                                            <Form.Label className='fw-bold'>Subject{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                            <Form.Control size="sm"
                                                type="text"
                                                value={rowFormData.subject}
                                                name='subject'
                                                onChange={handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid subject.
                                            </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3 h-50">
                                <Col>
                                    <Form.Group >
                                            <Form.Label className='fw-bold'>Email Body{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                            <JoditEditor 
                                                ref={editor}
                                                value={rowFormData.body}
                                                config={config}
                                                tabIndex={1} // tabIndex of textarea
                                                // onBlur={newContent =>  setFormData({ ...formData, body: newContent })} // preferred to use only this option to update the content for performance reasons
                                                // onChange={newContent => setFormData({ ...formData, body: newContent })}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid email body.
                                            </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row >
                                <Col>
                                <Form.Group controlId="formFile" >
                                    <Form.Label className='fw-bold'>Attachment(s)</Form.Label>
                                    <Form.Control size="sm" type="file" name='attachments' ref={attachmentRef} multiple/>
                                    <Form.Label className='fw-bold'>{rowFormData.attachments}</Form.Label>
                                </Form.Group>
                                </Col>
                            </Row>
                                            <Form.Control
                                                type="hidden"
                                                value={rowFormData.id}
                                                name='id'
                                            />

                                <div className='d-flex justify-content-end'>
                                {/* setShowForm(false);setFormData({});setmodifymode(false);setValidated(false);setGuidelinesShown(false) */}
                                
                                    <Button type='submit' className={`mx-1`} variant="primary" size="sm">Update</Button>
                                
                                </div>
                            
                        </Form>
            </Col>
        </Row>
       <Row> 
        <div className='p-2 d-flex justify-content-end'>
            <Form.Group as={Row} className='justify-content-end me-1' style={{width:'800px'}}>
                    <Form.Label className='fw-bold' column sm={6} >{message} {isSmtpCreadentialsValid}</Form.Label>
                    
                    <Col sm={6}>
                        <Select
                            key={selectKey}
                            ref={selectSmtpRef} 
                            className="sm"
                            isMulti={true}
                            backspaceRemovesValue={false}
                            closeMenuOnSelect={false}
                            value={selectedSmtpCredentials}
                            onChange={(value)=>setSelectedSmtpCredentials(value)}
                            options={smtpCredentials}
                            menuPlacement={"top"}
                            placeholder={'Select SMTP Servers'}
                            // components={animatedComponents}
                            // onInputChange={this.onInputChange}
                            // onMenuClose={this.onMenuClose}
                            // inputValue={this.state.inputValue}
                            // isDisabled={this.props.isCrawling}
                            // isOptionDisabled={() => ((this.state.keywords.length + this.state.selected.length) >= MAX_CATEGORIES_PER_LIST)}
                        />
                        {/* <Form.Select id="selectOptions" onChange={handlesmtpselect} isValid={isSmtpCreadentialsValid}>
                            <option key='default' value={-1}>
                                Select SMTP Credentials
                            </option>
                            {smtpCredentials.map((option, index) => (
                                <option key={index} value={option.id} >
                                    [ID-{props.uid}00{option.id}] {option.title}  
                                </option>
                            ))}
                        </Form.Select> */}
                    </Col>
                </Form.Group>
            <Button className='mx-1' title='Cancel' variant="secondary" onClick={handleCancel} size='sm'>
                Cancel
            </Button>
            <Button className={`mx-1`} title='Start a campaign with selected Template' variant="primary" onClick={startcampaign} size='sm'>
                Start Campaign
            </Button>
        </div>
        </Row>
    </div>

    <Modal show={showAddEmailModal} centered>
        <Modal.Body className='p-2 shadow'>
          <Form noValidate validated onSubmit={handleAddEmails}>
            <div className='d-flex flex-column'>
              <Form.Group className="m-3" controlId="emails">
                <Form.Label className='fs-6 fw-bold'>Emails</Form.Label>
                <Form.Control
                  name="emails"
                  type='text'
                  required
                  placeholder='Enter Emails'
                  autoFocus
                  onChange={(e)=>setEmailsForAdding(e.target.value)}
                />
                {/* <Form.Control.Feedback type="invalid"> </Form.Control.Feedback> */}
              </Form.Group>
            </div>
            <div className='p-2 d-flex justify-content-end'>
              <Button className='mx-1' variant="secondary" onClick={()=>setShowAddEmailModal(false)}>
                Cancel
              </Button>
              <Button type="submit" className={`mx-1 ${(emailsForAdding === '') ? 'disabled' : ''}`} variant="primary" >
                Ok
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
}

export default CreateCampaign;